import React from 'react'
import styled, { css, up } from '@xstyled/styled-components'

export const Container = styled.box`
  max-width: container-base;
  padding-left: 4;
  padding-right: 4;
  margin: 0 auto;
`

export const ContainerFooter = styled.box`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: container-base;
  margin: 4 auto;

  ${up(
    'md',
    css`
      display: flex;
      flex-direction: row;
      max-width: container-base;
      padding-left: 4;
      padding-right: 4;
      margin: 0 auto;
    `,
  )}
`

export const ContainerNewsletter = styled.box`
  max-width: container-newsletter;
  padding-left: 4;
  padding-right: 4;
  margin: 0 auto;
`

export function PageContainer(props) {
  return <Container pt={{ xs: 120, md: 8 }} pb={5} {...props} />
}
